import { render, staticRenderFns } from "./basic-related-tip.vue?vue&type=template&id=660c9138&scoped=true"
import script from "./basic-related-tip.vue?vue&type=script&lang=js"
export * from "./basic-related-tip.vue?vue&type=script&lang=js"
import style0 from "./basic-related-tip.vue?vue&type=style&index=0&id=660c9138&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "660c9138",
  null
  
)

export default component.exports